import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './AppLayout';
import { RequireAdmin } from './RequireAdmin';
import { RequireSignedIn } from './RequireSignedIn';
import { HomePage } from '../features/home/pages/HomePage';
import { UnauthorizedPage } from '../features/home/pages/UnauthorizedPage';
import { AdminLoginPage } from '../features/auth/pages/AdminLoginPage';
import { AdminDashboardPage } from '../features/admin/pages/AdminDashboardPage';
import { AdminCompanyDetailPage } from '../features/admin/pages/AdminCompanyDetailPage';
import { CompanyInvitationsPage } from '../features/admin/pages/CompanyInvitationsPage';
import { DiscountCodeListPage } from '../features/admin/pages/DiscountCodeListPage';
import { FeatureFlagListPage } from '../features/admin/pages/FeatureFlagListPage';
import { AdminAuditLogPage } from '../features/admin/pages/AdminAuditLogPage';
import { SecurityDashboardPage } from '../features/admin/pages/SecurityDashboardPage';
import { ApiActivityPage } from '../features/admin/pages/ApiActivityPage';
import { DownloadAlertsPage } from '../features/admin/pages/DownloadAlertsPage';
import { ShopifyComplianceRequestListPage } from '../features/admin/pages/ShopifyComplianceRequestListPage';
import { ShopifyComplianceRequestDetailPage } from '../features/admin/pages/ShopifyComplianceRequestDetailPage';
import { MerchantsListPage } from '../features/merchants/pages/MerchantsListPage';
import { MerchantDetailPage } from '../features/merchants/pages/MerchantDetailPage';
import { MerchantEditPage } from '../features/merchants/pages/MerchantEditPage';
import { MerchantInvitePage } from '../features/merchants/pages/MerchantInvitePage';
import { RouteErrorFallback } from './RouteErrorFallback';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorFallback />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'unauthorized', element: <UnauthorizedPage /> },
      { path: 'login/admin', element: <AdminLoginPage /> },
      {
        path: 'admin',
        element: <RequireSignedIn />,
        children: [
          {
            element: <RequireAdmin />,
            children: [
              { path: 'dashboard', element: <AdminDashboardPage /> },
              { path: 'discount-codes', element: <DiscountCodeListPage /> },
              { path: 'feature-flags', element: <FeatureFlagListPage /> },
              { path: 'companies/:companyId', element: <AdminCompanyDetailPage /> },
              { path: 'invitations', element: <CompanyInvitationsPage /> },
              { path: 'audit-logs', element: <AdminAuditLogPage /> },
              { path: 'security', element: <SecurityDashboardPage /> },
              { path: 'security/api-activity', element: <ApiActivityPage /> },
              { path: 'security/download-alerts', element: <DownloadAlertsPage /> },
              { path: 'shopify-compliance-requests', element: <ShopifyComplianceRequestListPage /> },
              { path: 'shopify-compliance-requests/:id', element: <ShopifyComplianceRequestDetailPage /> },
            ],
          },
        ],
      },
      {
        path: 'merchants',
        element: <RequireSignedIn />,
        children: [
          { index: true, element: <MerchantsListPage /> },
          { path: 'invite', element: <MerchantInvitePage /> },
          { path: ':merchantId/edit', element: <MerchantEditPage /> },
          { path: ':merchantId', element: <MerchantDetailPage /> },
        ],
      },
    ],
  },
]);
